import { type FC, memo, type ReactNode, useCallback, useState } from "react";
import BulkATCPopup from "./BulkATCPopup";
import { sendPopupOpen } from "../../feature/Analytics/ga/bulkUpload";

interface RenderProps {
  openPopup: () => void;
  closePopup: () => void;
}

interface BulkATCPopupContextProps {
  children: (props: RenderProps) => ReactNode;
}

const BulkATCPopupContext: FC<BulkATCPopupContextProps> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openPopup = useCallback(() => {
    setOpen(true);
    sendPopupOpen();
  }, []);
  const closePopup = useCallback(() => setOpen(false), []);

  const props = { openPopup, closePopup };

  return (
    <>
      {children(props)}
      {open && <BulkATCPopup onClose={closePopup} />}
    </>
  );
};
export default memo(BulkATCPopupContext);
